export const list = {
  name: {
    name: '部门名称',
    key: 'name',
    width: 350
  },
  all_number_of_employees: {
    name: ' 部门人数',
    key: 'all_number_of_employees',
    width: 200
  },
  department_header_user_info: {
    name: '负责人',
    key: 'department_header_user_info'
  }
};
